import React from "react";
import { StarIcon as StarSolid } from "@heroicons/react/24/solid";
import { 
    CheckBadgeIcon, 
    ChatBubbleBottomCenterTextIcon, 
    ArrowTrendingUpIcon,
    CurrencyDollarIcon
} from "@heroicons/react/24/outline";

const PerformanceReviews = () => {
  return (
    <div className="p-4 md:p-8 bg-[#f8fafc] min-h-screen font-roboto">
      <div className="max-w-5xl mx-auto">
        <header className="mb-10">
            <h2 className="text-3xl font-poppins font-bold text-slate-900">Review Evaluations</h2>
            <p className="text-sm text-slate-500 mt-1 font-medium">Step 4: Analyze self-appraisals and recommend compensation adjustments.</p>
        </header>

        <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
          {/* Employee Header Info */}
          <div className="p-8 border-b border-slate-100 flex flex-col md:flex-row justify-between items-center gap-6">
              <div className="flex items-center gap-5">
                <div className="h-16 w-16 bg-indigo-600 rounded-2xl flex items-center justify-center text-white text-xl font-bold shadow-lg shadow-indigo-100">JD</div>
                <div>
                  <h3 className="text-xl font-poppins font-bold text-slate-900">Johnathan Doe</h3>
                  <p className="text-xs font-bold text-indigo-600 uppercase tracking-widest mt-1">Lead Software Engineer</p>
                </div>
              </div>
              <div className="flex gap-3">
                <span className="px-4 py-2 bg-amber-50 text-amber-600 text-[10px] font-black uppercase rounded-xl border border-amber-100">Review Pending</span>
              </div>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              
              {/* LEFT: KPI Evaluation Section */}
              <div className="lg:col-span-2 space-y-10">
                <h4 className="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em] flex items-center gap-2">
                    <CheckBadgeIcon className="h-4 w-4 text-indigo-500" /> Scoring Metrics
                </h4>
                
                {[1, 2].map((item) => (
                  <div key={item} className="space-y-4">
                    <div className="flex justify-between items-end">
                      <span className="font-bold text-slate-800">Code Quality & Unit Testing</span>
                      <span className="text-[10px] font-bold text-slate-400 uppercase bg-slate-100 px-2 py-1 rounded">Weight: 40%</span>
                    </div>
                    {/* Employee's Self Appraisal Data from Step 3 */}
                    <div className="bg-indigo-50/50 p-4 rounded-2xl border-l-4 border-indigo-500 relative">
                        <span className="absolute -top-2 left-4 px-2 bg-indigo-500 text-white text-[8px] font-bold rounded">EMPLOYEE SELF-NOTE</span>
                        <p className="text-xs leading-relaxed text-indigo-900 font-medium italic">
                            "I maintained a 98% test coverage across all new modules and mentored 2 junior developers during the Alpha sprint."
                        </p>
                        <p className="mt-2 text-[10px] font-bold text-indigo-600 uppercase">Self Rating: 4.5 / 5.0</p>
                    </div>
                    {/* Manager's Rating Action */}
                    <div className="flex items-center gap-4 pt-2">
                        <span className="text-xs font-bold text-slate-500 uppercase">Manager Score:</span>
                        <div className="flex gap-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                            <StarSolid key={star} className={`h-6 w-6 cursor-pointer transition-all ${star <= 4 ? "text-amber-400" : "text-slate-200 hover:text-amber-200"}`} />
                            ))}
                        </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* RIGHT: Manager Recommendation Section (Crucial for Step 5) */}
              <div className="space-y-8">
                <div className="bg-slate-900 rounded-3xl p-6 text-white shadow-2xl">
                    <h4 className="text-[10px] font-black text-indigo-300 uppercase tracking-widest mb-6">Compensation Proposal</h4>
                    
                    <div className="space-y-6">
                        <div>
                            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-2">Recommended Hike %</label>
                            <div className="relative">
                                <input type="number" className="w-full bg-white/10 border border-white/10 rounded-xl p-3 text-sm font-bold text-white outline-none focus:border-indigo-500" placeholder="e.g. 12" />
                                <ArrowTrendingUpIcon className="h-4 w-4 absolute right-3 top-3 text-slate-500" />
                            </div>
                        </div>
                        <div>
                            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-2">Performance Bonus (USD)</label>
                            <div className="relative">
                                <input type="number" className="w-full bg-white/10 border border-white/10 rounded-xl p-3 text-sm font-bold text-white outline-none focus:border-indigo-500" placeholder="e.g. 2500" />
                                <CurrencyDollarIcon className="h-4 w-4 absolute right-3 top-3 text-slate-500" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="space-y-4">
                    <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Growth Feedback</h4>
                    <textarea 
                        rows="5" 
                        placeholder="Discuss strengths and areas for improvement..."
                        className="w-full p-4 bg-white border border-slate-200 rounded-2xl text-sm outline-none focus:ring-4 focus:ring-indigo-500/5 focus:border-indigo-500 transition-all"
                    ></textarea>
                </div>
              </div>

            </div>
          </div>

          <div className="p-8 bg-slate-50 border-t border-slate-100 flex justify-end">
            <button className="bg-slate-900 text-white px-10 py-4 rounded-2xl text-[11px] font-black uppercase tracking-[0.2em] hover:bg-indigo-600 transition-all shadow-xl shadow-slate-200">
                Submit Review to HR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PerformanceReviews;